import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  groups: null,
};
export const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    setGroups: (state, action) => {
      state.groups = action.payload;
    },
    setLogoutGroups: (state, action) => {
      state.groups = null;
    },
  },
});
export const { setGroups, setLogoutGroups } = groupsSlice.actions;

export default groupsSlice.reducer;
